export const PORTAL_POST_LOGIN_PATH_KEY = "portalPostLoginPath";

export function getKeycloakLoginRedirectUri(): string {
  return `${window.location.origin}${window.location.pathname}`;
}

export function rememberPostLoginPath(fullPath: string): void {
  if (!fullPath || fullPath === "/" || fullPath === "/welcome") {
    sessionStorage.setItem(PORTAL_POST_LOGIN_PATH_KEY, "/dashboard");
    return;
  }
  sessionStorage.setItem(PORTAL_POST_LOGIN_PATH_KEY, fullPath);
}

export function consumePostLoginPath(): string | null {
  const v = sessionStorage.getItem(PORTAL_POST_LOGIN_PATH_KEY);
  if (v) {
    sessionStorage.removeItem(PORTAL_POST_LOGIN_PATH_KEY);
  }
  return v;
}

/** Post-login deep link if stored, otherwise the main app home route. */
export function resolveAuthenticatedEntryPath(): string {
  return consumePostLoginPath() || "/dashboard";
}
